import { createTheme } from '@mui/material/styles';
import { BRAND } from './constants/branding';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: BRAND.colors.primaryDark,
      light: BRAND.colors.primary,
      dark: '#002299',
      contrastText: '#fff',
    },
    secondary: {
      main: BRAND.colors.primary,
      light: '#33DDFF',
      dark: '#00A8C9',
      contrastText: '#05070a',
    },
    background: {
      default: '#F4F6FB',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#64748B',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 800, letterSpacing: '-0.03em' },
    h2: { fontSize: '2rem', fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontSize: '1.75rem', fontWeight: 700 },
    h4: { fontSize: '1.5rem', fontWeight: 700 },
    h5: { fontSize: '1.25rem', fontWeight: 600 },
    h6: { fontSize: '1rem', fontWeight: 600 },
    button: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 10, fontWeight: 600 },
        containedPrimary: {
          background: BRAND.gradient,
          boxShadow: `0 4px 16px ${BRAND.colors.glow}`,
          '&:hover': {
            background: BRAND.gradient,
            filter: 'brightness(1.06)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 14, boxShadow: '0 2px 16px rgba(15,23,42,0.06)' },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: `1px solid ${BRAND.colors.border}`,
        },
      },
    },
  },
});
